/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:25
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-11-13 15:08:25
 * @FilePath: \mall\src\utils\setGlobalColor.js
 * @Description: 全局主题色。默认从 color.config 兜底，可由首页接口下发的 home_config 动态覆盖。
 */
import colorConfig from '@/config/color.config'
import Vue from 'vue'
import { getShopConfigApi } from '@/api/home'

// 设置全局颜色（兜底默认值）
Vue.prototype.$GColor = colorConfig

// 六位十六进制色值校验，与后台约定一致：#RRGGBB
const HEX_COLOR_RE = /^#([0-9A-Fa-f]{6})$/

// home_config 主题字段 → 全局 CSS 变量映射
// 文档：title_color=主色 sub_color=第二色 assist_color=第三色 title_font_color=标题字体色
const THEME_FIELD_MAP = {
  title_color: 'primaryColor',
  sub_color: 'secondaryColor',
  assist_color: 'tertiaryColor',
  title_font_color: 'titleFontColor'
}

// 写入单个 CSS 变量
function setCssVar(key, value) {
  document.documentElement.style.setProperty(
    `--${key}`,
    value
  )
}

// 应用一组 { cssVarKey: colorValue } 到 :root
function applyColors(colors) {
  for (const [key, value] of Object.entries(colors)) {
    setCssVar(key, value)
  }
}

// 初始化：写入默认兜底色
applyColors(colorConfig)

/**
 * 根据首页接口返回的 home_config 动态设置全局主题色。
 * 只覆盖显式提供且格式合法的字段，其余沿用当前值（兜底 / 平台底层配置）。
 * @param {object} homeConfig data.home_config，含 theme / title_color / title_font_color / sub_color / assist_color
 * @returns {object} 实际应用的 { cssVarKey: colorValue }
 */
export function setGlobalColor(homeConfig) {
  if (!homeConfig || typeof homeConfig !== 'object')
    return {}

  const applied = {}
  for (const [field, cssVarKey] of Object.entries(
    THEME_FIELD_MAP
  )) {
    const value = homeConfig[field]
    if (
      typeof value === 'string' &&
      HEX_COLOR_RE.test(value)
    ) {
      applied[cssVarKey] = value
    }
  }

  applyColors(applied)

  // 同步更新全局引用，方便 JS 侧（如 $colorConfig / this.config?.theme 兜底）读取最新主色
  if (applied.primaryColor) {
    Vue.prototype.$GColor = { ...colorConfig, ...applied }
  }

  return applied
}

/**
 * 从商城基本配置接口拉取主题并应用（全局调用，免鉴权）。
 * GET /home/shop-config → data.home_config { theme, title_color, ... }。
 * 接口异常 / 无配置时静默回退到默认兜底色，不影响页面渲染。
 * @returns {Promise<object>} 实际应用的 { cssVarKey: colorValue }
 */
export async function fetchAndApplyTheme() {
  try {
    const result = await getShopConfigApi()
    const homeConfig = result?.data?.data?.home_config
    return homeConfig ? setGlobalColor(homeConfig) : {}
  } catch (e) {
    // 拉取失败保持默认兜底色
    return {}
  }
}

export default setGlobalColor
